var _rect, _rect2, _rect3, _path, _rect4, _rect5, _rect6, _rect7, _path2, _rect8, _rect9, _rect10, _rect11, _path3, _rect12, _rect13, _rect14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoPracticeProblems(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 231,
    height: 192,
    viewBox: "0 0 231 192",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.8018,
    y: 9.52067,
    width: 140.43,
    height: 182.479,
    rx: 8,
    fill: "#33363E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2314,
    y: 35.7025,
    width: 138.05,
    height: 34.9091,
    rx: 4,
    fill: "#42464D"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 80.2314,
    y: 47.7025,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#888B8F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4715 52.5568C96.6535 52.6322 96.8189 52.7428 96.9582 52.8822C97.2394 53.1635 97.3974 53.5449 97.3974 53.9426C97.3974 54.3404 97.2393 54.7219 96.9581 55.0032L89.4628 62.4985C89.3174 62.644 89.1446 62.7594 88.9545 62.8382C88.7644 62.9169 88.5607 62.9574 88.3549 62.9574C88.1491 62.9574 87.9454 62.9169 87.7553 62.8382C87.5652 62.7594 87.3925 62.644 87.247 62.4985L83.5258 58.7779C83.3841 58.6402 83.2711 58.4759 83.1931 58.2944C83.1145 58.1114 83.0731 57.9145 83.0713 57.7154C83.0696 57.5162 83.1076 57.3187 83.183 57.1343C83.2584 56.95 83.3698 56.7825 83.5106 56.6417C83.6515 56.5008 83.8189 56.3894 84.0033 56.314C84.1876 56.2386 84.3852 56.2006 84.5843 56.2024C84.7835 56.2041 84.9803 56.2455 85.1633 56.3241C85.3449 56.4021 85.5092 56.5152 85.6469 56.6568L88.3546 59.3645L94.8363 52.8821C94.9756 52.7427 95.141 52.6322 95.323 52.5568C95.505 52.4813 95.7002 52.4425 95.8972 52.4425C96.0943 52.4425 96.2894 52.4813 96.4715 52.5568Z",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 104.231,
    y: 47.7025,
    width: 126,
    height: 8,
    rx: 2,
    fill: "#888B8F"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 104.231,
    y: 59.7025,
    width: 95.81,
    height: 8,
    rx: 2,
    fill: "#888B8F"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 68.2314,
    y: 130.909,
    width: 138.05,
    height: 34.9091,
    rx: 4,
    fill: "#42464D"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 80.2314,
    y: 142.909,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#888B8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M96.4715 147.763C96.6535 147.839 96.8189 147.949 96.9582 148.089C97.2394 148.37 97.3974 148.752 97.3974 149.149C97.3974 149.547 97.2393 149.928 96.9581 150.21L89.4628 157.705C89.3174 157.851 89.1446 157.966 88.9545 158.045C88.7644 158.124 88.5607 158.164 88.3549 158.164C88.1491 158.164 87.9454 158.124 87.7553 158.045C87.5652 157.966 87.3925 157.851 87.247 157.705L83.5258 153.985C83.3841 153.847 83.2711 153.683 83.1931 153.501C83.1145 153.318 83.0731 153.121 83.0713 152.922C83.0696 152.723 83.1076 152.525 83.183 152.341C83.2584 152.157 83.3698 151.989 83.5106 151.848C83.6515 151.707 83.8189 151.596 84.0033 151.521C84.1876 151.445 84.3852 151.407 84.5843 151.409C84.7835 151.411 84.9803 151.452 85.1633 151.531C85.3449 151.609 85.5092 151.722 85.6469 151.863L88.3546 154.571L94.8363 148.089C94.9756 147.949 95.141 147.839 95.323 147.763C95.505 147.688 95.7002 147.649 95.8972 147.649C96.0943 147.649 96.2894 147.688 96.4715 147.763Z",
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 104.231,
    y: 142.909,
    width: 126,
    height: 8,
    rx: 2,
    fill: "#888B8F"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 104.231,
    y: 154.909,
    width: 95.81,
    height: 8,
    rx: 2,
    fill: "#888B8F"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    y: 83.3058,
    width: 138.05,
    height: 34.9091,
    rx: 4,
    fill: "#42464D"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 12,
    y: 95.3058,
    width: 20,
    height: 20,
    rx: 4,
    fill: "#888B8F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M28.24 100.16C28.4221 100.236 28.5875 100.346 28.7268 100.485C29.008 100.767 29.1659 101.148 29.1659 101.546C29.1659 101.944 29.0079 102.325 28.7267 102.606L21.2314 110.102C21.0859 110.247 20.9132 110.363 20.7231 110.441C20.533 110.52 20.3292 110.561 20.1235 110.561C19.9177 110.561 19.7139 110.52 19.5238 110.441C19.3337 110.363 19.161 110.247 19.0155 110.102L15.2944 106.381C15.1527 106.244 15.0396 106.079 14.9616 105.898C14.883 105.715 14.8416 105.518 14.8399 105.319C14.8382 105.119 14.8761 104.922 14.9515 104.738C15.027 104.553 15.1383 104.386 15.2792 104.245C15.42 104.104 15.5875 103.993 15.7718 103.917C15.9562 103.842 16.1537 103.804 16.3529 103.806C16.552 103.807 16.7489 103.849 16.9319 103.927C17.1134 104.005 17.2778 104.118 17.4154 104.26L20.1231 106.968L26.6049 100.485C26.7442 100.346 26.9095 100.235 27.0916 100.16C27.2736 100.085 27.4687 100.046 27.6658 100.046C27.8629 100.046 28.058 100.085 28.24 100.16Z",
    fill: "white"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 95.3058,
    width: 126,
    height: 8,
    rx: 2,
    fill: "#888B8F"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 36,
    y: 107.306,
    width: 95.81,
    height: 8,
    rx: 2,
    fill: "#888B8F"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    width: 78.5454,
    height: 24.595,
    rx: 8,
    transform: "matrix(1 0 0 -1 54.7441 24.595)",
    fill: "#2C2F35"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoPracticeProblems);
export default __webpack_public_path__ + "static/media/NoPracticeProblems.a867398389c428477662194154c21ecd.svg";
export { ForwardRef as ReactComponent };